module.exports = __webpack_public_path__ + "img/ch72.456d1867.png";